import { ref, computed } from '@vue/composition-api'
import axios from 'crypto-fetch/axios'
import { marketMap } from '@ms/utils/sports/market.js'
import { generateArray } from '@ms/utils/array'
import { setMarketInfo, setSuperMarketInfo } from '@ms/components/match/marketBus.js'

// 当前可用 market map 列表
const marketsMap = ref({})

/* sports default market list 了 */
export default function useDefaultMarket() {
  // default markets info list
  const defaultMarkets = ref([])
  const otherMarkets = ref([])
  const otherDefaultMarkets = ref([])
  const specialMarkets = ref([])

  const updateMarketMap = (option) => {
    marketsMap.value = getMarketMap(option)
  }

  // 获取Market列表与详细信息，用于组成切换market的菜单, 默认不获取 other markets
  const getMarketInfo = async ({ sportId = '', withOthers = false }) => {
    const market = marketMap.get(sportId)

    let data = market
    if (!market || (!market.withOthers && withOthers)) {
      data = await axios.get('/facts-center/query/frontend/default-market-info', {
        params: {
          sportId,
          withOthers: withOthers ? 1 : 0
        }
      })
      marketMap.set(sportId, data, { withOthers })
    }

    const { markets, ...rest } = data
    defaultMarkets.value = markets
    otherMarkets.value = rest.otherMarkets
    otherDefaultMarkets.value = rest.otherDefaultMarkets
    updateMarketMap({ defaultMarkets: markets, ...rest })
    setMarketInfo(sportId, data)
  }

  // 获取Super Market列表与详细信息，用于组成切换market的菜单
  const getSuperMarketInfo = async (sportId = '') => {
    const market = marketMap.get(sportId)
    if (market && market.specialMarkets) {
      specialMarkets.value = market.specialMarkets
    } else {
      const data = await axios.get('/facts-center/query/frontend/super-market-info', {
        params: { sportId }
      })
      specialMarkets.value = Object.values(data.markets).reduce((pre, cur) => pre.concat(cur))
      marketMap.addSpecialMarket(sportId, specialMarkets.value)
    }
    updateMarketMap({
      defaultMarkets: defaultMarkets.value,
      otherDefaultMarkets: otherDefaultMarkets.value,
      otherMarkets: otherMarkets.value,
      specialMarkets: specialMarkets.value
    })
    setSuperMarketInfo(sportId, specialMarkets.value)
  }

  // 集合defaultMarkets、otherMarkets以及otherDefaultMarkets
  const marketGroupList = computed(() => [
    ['Popular Markets', defaultMarkets.value.concat(otherDefaultMarkets.value)],
    ...otherMarkets.value.map((market) => [market.name, market.marketInfos]),
    ['Special Markets', specialMarkets.value]
  ])

  const marketIds = computed(() => defaultMarkets.value.map((x) => x.id))

  return {
    defaultMarkets,
    otherMarkets,
    otherDefaultMarkets,
    marketsMap,
    marketGroupList,
    marketIds,
    getMarketInfo,
    getSuperMarketInfo
  }
}

// 解析普通 market titles
const getMarketTitles = (title) => title && title.split(',')
// 解析 special market titles
const getSpecialMarketTitles = (presentationType, outcomeNumber) => {
  let titles = []
  if (presentationType === 7) {
    const end = outcomeNumber < 4 ? outcomeNumber : 4
    titles = generateArray(1, end)
  } else {
    titles = generateArray(0, outcomeNumber - 1)
    titles[titles.length - 1] = titles[titles.length - 1] + '+'
  }
  return titles
}

function getMarketMap({ defaultMarkets, otherDefaultMarkets, otherMarkets, specialMarkets }) {
  const res = {}
  // default markets
  defaultMarkets.forEach((x) => {
    res[x.id] = {
      ...x,
      title: getMarketTitles(x.title)
    }
  })

  // otherDefaultMarkets
  otherDefaultMarkets.forEach((x) => {
    res[x.id] = {
      ...x,
      title: getMarketTitles(x.title)
    }
  })
  // otherMarkets
  otherMarkets.forEach(({ marketInfos }) =>
    marketInfos.forEach(
      (x) =>
        (res[x.id] = {
          ...x,
          title: getMarketTitles(x.title)
        })
    )
  )

  if (specialMarkets) {
    specialMarkets.forEach((x) => {
      res[x.id] = {
        ...x,
        title: getSpecialMarketTitles(x.presentationType, x.outcomeNumber)
      }
    })
  }

  return res
}
